import { cn } from '@/core/utils/common'

import type { ReactNode } from 'react'

/**
 * 상세 화면 섹션 하나 — 제목(+부제·오른쪽 링크) + 본문.
 * 2026-10-07 갈아엎기 — 테두리 상자(레퍼런스 .box) · 제목 앞 아이콘을 걷고 홈 섹션 머리(feed-home H2)와 같은 크기의 평평한 섹션으로.
 * 섹션끼리는 위 여백으로만 나눈다. 안쪽에 판이 필요하면(미리보기 · 표) 본문이 직접 옅은 판을 깐다.
 */
export default function DetailBox({
  title,
  sub,
  right,
  extra,
  className,
  children,
}: {
  title: ReactNode
  sub?: ReactNode
  right?: ReactNode
  extra?: ReactNode
  className?: string
  children?: ReactNode
}) {
  return (
    <section className={cn('pt-8 over10:pt-10', className)}>
      <h2 className="flex items-center justify-between gap-3">
        <span className="min-w-0 truncate text-c17 leading-[1.3] font-bold tracking-[-0.01em] text-t1 over10:text-c18">
          {title}
        </span>
        {sub && (
          <span className="flex-none text-c12 font-medium text-t3 over10:text-c13">
            {sub}
          </span>
        )}
        {right}
      </h2>
      {children}
      {extra}
    </section>
  )
}
